import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { isInIframe } from '@/standalone';
const StandaloneLayout: React.FC = () => {
  // Listen for messages from the parent app (e.g., auth token refresh)
  useEffect(() => {
    if (!isInIframe()) return;

    const handleMessage = (event: MessageEvent) => {
      const { data } = event;
      if (data?.source !== 'vms-hub-parent') return;
      // Handle parent-to-iframe messages here as needed
      // Example: if (data.type === 'AUTH_REFRESH') { ... }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default StandaloneLayout;
